import { cpf, cnpj } from 'cpf-cnpj-validator'

export const CPF_REGEX = /^(\d{3})(\d{3})(\d{3})(\d{2})$/
export const CNPJ_REGEX = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/

export const cpfMask = value => {
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}

export const cnpjMask = value => {
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{2})(\d)/, '$1.$2') // formata os dois primeiros números
    .replace(/(\d{3})(\d)/, '$1.$2') // formata os três primeiros números antes do traço
    .replace(/(\d{3})(\d)/, '$1/$2') // formata os três últimos números antes do traço
    .replace(/(\d{4})(\d)/, '$1-$2') // formata os últimos números depois do traço
    .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}

export const isValidCpf = value => cpf.isValid(value)

export const isValidCnpj = value => cnpj.isValid(value)

export const isValidDocument = (value, type) => {
  if (type === 'cpf') {
    return isValidCpf(value)
  }
  if (type === 'cnpj') {
    return isValidCnpj(value)
  }
  return false
}

export const getMaskedValue = (value, type) => {
  if (type === 'cpf') {
    return cpfMask(value)
  }
  if (type === 'cnpj') {
    return cnpjMask(value)
  }
  return value
}

export const getDocumentType = value => {
  const onlyDigitsAndAsterisks = value.replace(/[^\d*]/g, '')
  return onlyDigitsAndAsterisks.length === 11 ? 'cpf' : 'cnpj'
}

export const getUnmaskedDocument = value => {
  return value.replace(/[^\d*]/g, '')
}

export const getMaskedDocument = value => {
  const onlyDigitsAndAsterisks = value.replace(/[^\d*]/g, '')
  const isCPF = onlyDigitsAndAsterisks.length === 11

  const cpfMask = '000.000.000-00'
  const cnpjMask = '00.000.000/0000-00'

  const mask = isCPF ? cpfMask : cnpjMask

  let maskedValue = ''
  let index = 0

  maskedValue = mask.replace(/./g, char => {
    if (char === '0' && index < onlyDigitsAndAsterisks.length) {
      const digit = onlyDigitsAndAsterisks.charAt(index)
      index++
      return digit
    }
    return char
  })

  return maskedValue
}
